import { rgba } from 'polished';
import styled from 'styled-components';
import { color, container, fontSize, screen, spacing } from 'theme';
import { getPublicPath } from 'utils/paths';

export const StyledSection = styled.div`
  background-color: ${color('midnight_900')};
  background-image: linear-gradient(
      ${rgba('#1f1d26', 0.75)},
      ${rgba('#1f1d26', 0.75)}
    ),
    url('${getPublicPath('/images/stateSector/hero-bg.gif')}');
  background-size: cover;
  padding: ${spacing('xl5')} ${spacing('md')};
`;

export const StyledContainer = styled.div`
  max-width: ${container('md')};
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing('xl')};
  color: ${color('text_default_inverse')};

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
  }
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing('md')};

  p {
    margin: 0;
    font-size: ${fontSize('lg')};
    line-height: 1.6;
  }
`;

export const StyledImage = styled.div`
  width: 18rem;
  flex-shrink: 0;

  img {
    display: block;
  }
`;
